import React from 'react';
import { type ProtectedUrlModalProps } from './constants';
import { InvalidUrlModal } from './InvalidUrlModal';
import { ValidUrlModal } from './ValidUrlModal';

export const ProtectedUrlModal = ({
    event,
    onAddUrlToAllowList,
    ...rest
}: ProtectedUrlModalProps) => {
    const { url, newTab, isInvalidUrl } = event ?? {};

    return isInvalidUrl ? (
        <InvalidUrlModal url={url} {...rest} />
    ) : (
        <ValidUrlModal
            url={url}
            newTab={newTab}
            onAddUrlToAllowList={onAddUrlToAllowList}
            {...rest}
        />
    );
};
